enum AvailabilityError {
  IsSold = 'IsSold',
  None = 'None',
  NotAvailableInCA = 'NotAvailableInCA',
  OnSitePrivate = 'OnSitePrivate',
  OutOfMarket = 'OutOfMarket',
  OutOfMarketNewCar = 'OutOfMarketNew',
  PurchasePending = 'PurchasePending',
  StopSaleRecall = 'StopSaleRecall',
  Unavailable = 'Unavailable',
  UnavailableReserved = 'UnavailableReserved'
}

export default AvailabilityError;
